import React from "react";

export default function OurMission() {
  return (
    <div className="bg-white/80 p-4 rounded-xl shadow-sm border mb-4">
      <div className="text-xl font-semibold mb-2">Welcome to ReportMaster.ai</div>
      <div className="text-gray-700 mb-2">
        Your Personal AI Report Generator – Fast, Smart, and Tailored to Your Needs
      </div>
      <div className="text-gray-700 leading-relaxed">
        <span className="font-bold">At ReportMaster.ai, our mission is simple:</span><br />
        To empower individuals and organizations with fast, accurate, and intelligently structured reports.<br />
        We simplify the process of turning ideas, data, and goals into actionable documents — enabling better decisions, clearer communication, and greater efficiency.<br />
        Our goal is to make high-quality reporting accessible, intuitive, and dependable for everyone.
      </div>
    </div>
  );
}